import { Column } from "../../interfaces/table.interface";
import { TuitionRequestInterface } from "../../interfaces/tuitionRequest.interface";
import CoinsDisplay from "./CoinsDisplay";

export const walletColumns: Column[] = [
  {
    select: "totalNumberOfClasses",
    header: "Classes",
    align: "center",
    render: (_value, row: TuitionRequestInterface) =>
      row.totalNumberOfClasses ??
      row.requiredNumberOfClasses ??
      "—",
  },
  {
    select: "gcChargePerClass",
    header: "GC / class",
    align: "right",
    render: (_value, row: TuitionRequestInterface) => (
      <CoinsDisplay
        value={
          row.parentShadowWallet?.gcChargePerClass ??
          row.gcChargePerClass
        }
      />
    ),
  },
  {
    select: "totalCoins",
    header: "Total GC",
    align: "right",
    render: (_value, row: TuitionRequestInterface) => (
      <CoinsDisplay
        value={
          row.parentShadowWallet?.totalCoinsAllocated ??
          row.totalCoins
        }
      />
    ),
  },
  {
    select: "currentCoins",
    header: "Current GC",
    align: "right",
    render: (_value, row: TuitionRequestInterface) => (
      <CoinsDisplay value={row.parentShadowWallet?.currentCoins} />
    ),
  },
];
